import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../../lib/api-client";
import { MaterialCostSearchResult } from "../types/MaterialCostSearchResult";
import { MaterialCostSearchParams } from "../types/MaterialCostSearchParams";

export const useGetMaterialCost = (params: MaterialCostSearchParams) => {
	const { data, refetch, isFetching, isRefetching } = useQuery({
		queryKey: [params],
		enabled: false,
		queryFn: async () => await apiClient.get('material-cost/details', {
			params: params
		}) as MaterialCostSearchResult
	});

	return {
		data,
		isLoading: isFetching || isRefetching,
		refetch
	};
};
